import { Card } from "react-bootstrap";
import { ErrorBoundary } from "@sentry/react";
import { DateTime } from 'luxon';
import * as Sentry from '@sentry/react';

import TideStat from "./TideStat.jsx";
import DataSource from "./DataSource.jsx";

import styles from './TideCard.module.css';


function TideCardError({error}) {
  Sentry.captureException(error);
  return (
    <Card.Body className={styles.TideCardBody}>
      <h4 className={styles.TideCardTitle}>This tide data failed to load...</h4>
      <p>
         The data might be unavailable or an error occurred. Please try again later.
      </p>
    </Card.Body>
  )
}

function TideCard({title, tideForecastData, dataSource, units}) {
  const tideDateForecastData = tideDataDateTransform(tideForecastData);

  return (
    <>
      <Card className={styles.TideCard}>
        <ErrorBoundary
          fallback={TideCardError}
        >
          <Card.Body className={styles.TideCardBody}>
            <h4 className={styles.TideCardTitle}>{title}</h4>
            <div className={styles.TideArea}>
              {tideDateForecastData.map((tideDate, index) => (
                <TideStat key={index} {...tideDate} units={units} />
              ))}
            </div>
          </Card.Body>
        </ErrorBoundary>
        <DataSource dataSource={dataSource} />
      </Card>
    </>
  )
}

function tideDataDateTransform(tideData) {
  if (!tideData) {
    return [
      {date: undefined, tides: undefined},
      {date: undefined, tides: undefined},
      {date: undefined, tides: undefined},
      {date: undefined, tides: undefined}
    ];
  }

  return tideData.reduce((acc, tide) => {
    const dateTime = DateTime.fromISO(tide.timestamp);
    const date = dateTime.toISODate();
    const existingDate = acc.find((tideDate) => tideDate.date === date);
    if (existingDate) {
      existingDate.tides.push(tide);
    } else {
      acc.push({
        date: date,
        tides: [tide],
      });
    }
    return acc;
  }, []);
}

export default TideCard
